import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './AuthContext';
import Login from './components/Login';
import Header from './components/Header';
import BulletinBoard from './components/BulletinBoard';
import AdminUsers from './components/AdminUsers';
import ContactInfo from './components/ContactInfo';
import DocumentArchive from './components/DocumentArchive';

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const { isAuthenticated, isLoading } = useAuth();

    if (isLoading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                Laster...
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    return <>{children}</>;
};

const AppLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    return (
        <div style={{ minHeight: '100vh' }}>
            <Header />
            <main style={{ backgroundColor: 'rgba(245, 245, 245, 0.9)', minHeight: 'calc(100vh - 60px)' }}>{children}</main>
        </div>
    );
};

const AppRoutes: React.FC = () => {
    const { isAuthenticated } = useAuth();

    return (
        <Routes>
            <Route
                path="/login"
                element={isAuthenticated ? <Navigate to="/" replace /> : <Login />}
            />
            <Route
                path="/"
                element={
                    <ProtectedRoute>
                        <AppLayout>
                            <BulletinBoard />
                        </AppLayout>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin"
                element={
                    <ProtectedRoute>
                        <AppLayout>
                            <AdminUsers />
                        </AppLayout>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/kontakter"
                element={
                    <ProtectedRoute>
                        <AppLayout>
                            <ContactInfo />
                        </AppLayout>
                    </ProtectedRoute>
                }
            />
            <Route
                path="/dokumenter"
                element={
                    <ProtectedRoute>
                        <AppLayout>
                            <DocumentArchive />
                        </AppLayout>
                    </ProtectedRoute>
                }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    );
};

const App: React.FC = () => {
    return (
        <BrowserRouter>
            <AuthProvider>
                <AppRoutes />
            </AuthProvider>
        </BrowserRouter>
    );
};

export default App;